"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.7 4.4a2.3 2.3 0 0 0-2.3 2.3v.15a.7.7 0 1 1-1.4 0V6.7A3.7 3.7 0 0 1 6.7 3h.15a.7.7 0 1 1 0 1.4zm5.75-.7a.7.7 0 0 1 .7-.7h.15A3.7 3.7 0 0 1 17 6.7v.15a.7.7 0 1 1-1.4 0V6.7a2.3 2.3 0 0 0-2.3-2.3h-.15a.7.7 0 0 1-.7-.7M3.7 12.45a.7.7 0 0 1 .7.7v.15a2.3 2.3 0 0 0 2.3 2.3h.15a.7.7 0 1 1 0 1.4H6.7A3.7 3.7 0 0 1 3 13.3v-.15a.7.7 0 0 1 .7-.7m12.6 0a.7.7 0 0 1 .7.7v.15a3.7 3.7 0 0 1-3.7 3.7h-.15a.7.7 0 1 1 0-1.4h.15a2.3 2.3 0 0 0 2.3-2.3v-.15a.7.7 0 0 1 .7-.7M5.3 8A2.7 2.7 0 0 1 8 5.3h4A2.7 2.7 0 0 1 14.7 8v4a2.7 2.7 0 0 1-2.7 2.7H8A2.7 2.7 0 0 1 5.3 12zM8 6.7A1.3 1.3 0 0 0 6.7 8v4A1.3 1.3 0 0 0 8 13.3h4a1.3 1.3 0 0 0 1.3-1.3V8A1.3 1.3 0 0 0 12 6.7z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.886 11.404c-.635.15-1.112.36-1.402.59l-.872-1.096c.518-.412 1.221-.684 1.954-.857a10.7 10.7 0 0 1 2.4-.259c.823 0 1.655.085 2.4.26.733.172 1.437.444 1.954.856l-.872 1.095c-.29-.23-.767-.44-1.402-.589a9.3 9.3 0 0 0-2.08-.222c-.733 0-1.456.076-2.08.222",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.896 8.397a.566.566 0 1 1-1.132 0 .566.566 0 0 1 1.132 0"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=CoverPhotoIcon20.js.map